// Put your applicaiton javascript here
$(function () {
    let props = {
        balls: '',
        pins: '',
        shackle: '',
        badge: ''
    };

    $("input[type='radio']").change(function (e) {
        e.preventDefault();
        props.balls = $(".balls:checked").val() || '';
        props.pins = $(".pins:checked").val();
        props.shackle = $(".shackle:checked").val() || '';
        props.badge = $(".badge:checked").val();
    })
    $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        swipe: false,
        infinite: false
    });
    $('.slider-nav').slick({
        arrows: false,
        slidesToShow: 5,
        slidesToScroll: 5,
        infinite: false,
        dots: false,
        centerMode: false,
        focusOnSelect: false,
        arrows: true,
        prevArrow: $('.prev'),
        nextArrow: $('.next'),
        variableWidth: true,
        responsive: [

            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            }, {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: false
                }
            }]
    });

    $('.product-single__thumbnails-item').click(function () {
        $('.slider-for').slick('slickGoTo',$(this).index());
    })

    $(".image-zoom").each(function () {
        $(this).zoom({url: $(this).find('img').attr('data-zoom')});
    })

    quantityProducts();
    $('.set a').click(function (e) {
        e.preventDefault();
        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this)
                .siblings(".content")
                .slideUp(200);
            $(this)
                .find('span').text('+');
        } else {
            $(".set a").removeClass("active");
            $(this).addClass("active");
            $(".content").slideUp(200);
            $(this)
                .siblings(".content")
                .slideDown(200);
            $(this)
                .find('span').text('-');
        }
    })
})

function quantityProducts() {
    let $quantityArrowMinus = $(".quantity__minus");
    let $quantityArrowPlus = $(".quantity__plus");
    let $quantityNum = $(".quantity__num");

    $quantityArrowMinus.click(quantityMinus);
    $quantityArrowPlus.click(quantityPlus);

    function quantityMinus(e) {
        e.preventDefault();
        if ($quantityNum.val() > 1) {
            $quantityNum.val(+$quantityNum.val() - 1);
        }
    }

    function quantityPlus(e) {
        e.preventDefault();
        $quantityNum.val(+$quantityNum.val() + 1);
    }
};